import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";

import { 
    listsetting1, listsetting2, listsetting3, seltypeorcategory,
    listsetting1_2, listsetting2_2, listsetting3_2,
    listsetting1_3, listsetting2_3, listsetting3_3,     
} from '../redux/userInfo';

import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Radios from './Radios';
import { DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";

import * as APIS from "../utils/service";

export default function ListsettingPop(props) {

    const {
        setlistsetpopstatus=() => {}
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { configdata } = useSelector(s => s.configReducer);
    const { seltypes, category_1s, 
        listset1, 
        listset2, 
        listset3, 
        listset1_2, 
        listset2_2, 
        listset3_2, 
        listset1_3, 
        listset2_3, 
        listset3_3, 
    } = useSelector(state => state.userInfo);


    let itemCates = configdata?.consts?.itemColums;
    //console.log(itemCates);
    const [radio1, setradio1] = useState(0);   

    const [sell_type, setsell_type] = useState(seltypes ? seltypes : 1);   
    const [sell_type_custom, setsell_type_custom] = useState(1);   
    const [category_1, setcategory_1] = useState(category_1s ? category_1s : 1);   
    
    let savelist1 = [
        {selltypeCker: [1,2,3], sellstatus: true, key: 'status', viewernames: '상태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'productcode', viewernames: '매물번호', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'create_dt', viewernames: '등록일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'update_dt', viewernames: '확인일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'mediation', viewernames: '공동중개', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'category_2name', viewernames: '매물종류', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'sigungu', viewernames: '시군구', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'dong', viewernames: '법정동', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'jibun', viewernames: '지번', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'title', viewernames: '건물(단지)명', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_dong', viewernames: '해당동', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_dong_floor_all', viewernames: '해당동 총층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_floor', viewernames: '해당층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_unit', viewernames: '호수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'area_supply', viewernames: '공급(타입)', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'area_private', viewernames: '전용면적', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_room', viewernames: '방/욕실수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'sell_type', viewernames: '거래형태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'price_sell', viewernames: '가격', disabled: true},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_all', viewernames: '현 보증금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_month', viewernames: '현 월세', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'revenue', viewernames: '수익률', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'realinvest', viewernames: '실 투자금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'pypricetype1', viewernames: '평당가(공급)', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'price_maintenance', viewernames: '관리비', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_households', viewernames: '세대수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car_all', viewernames: '총 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car', viewernames: '세대당 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_direction', viewernames: '방향', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_elevator', viewernames: '승강기', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'client_hp', viewernames: '연락처', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'user', viewernames: '담당자', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'matching', viewernames: '매칭', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_usage', viewernames: '용도', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_date', viewernames: '건축물일자', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'desc', viewernames: '비고', disabled: false},        
    ];
    let savelist2 = [
        {selltypeCker: [1,2,3], sellstatus: true, key: 'status', viewernames: '상태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'productcode', viewernames: '매물번호', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'create_dt', viewernames: '등록일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'update_dt', viewernames: '확인일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'mediation', viewernames: '공동중개', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'category_2name', viewernames: '매물종류', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'sigungu', viewernames: '시군구', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'dong', viewernames: '법정동', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'jibun', viewernames: '지번', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'title', viewernames: '건물명', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_dong', viewernames: '해당동', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_dong_floor_all', viewernames: '해당동 총층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_floor', viewernames: '해당층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_unit', viewernames: '호수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'area_contract', viewernames: '계약면적', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'area_private', viewernames: '전용면적', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_room', viewernames: '방/욕실수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'sell_type', viewernames: '거래형태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'price_sell', viewernames: '가격', disabled: true},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_all', viewernames: '현 보증금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_month', viewernames: '현 월세', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'revenue', viewernames: '수익률', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'realinvest', viewernames: '실 투자금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'pypricetype2', viewernames: '평당가(전용)', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'price_keymoney', viewernames: '권리금', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'price_maintenance', viewernames: '관리비', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car_all', viewernames: '총 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car', viewernames: '세대당 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_direction', viewernames: '방향', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_elevator', viewernames: '승강기', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'client_hp', viewernames: '연락처', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'user', viewernames: '담당자', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'matching', viewernames: '매칭', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_usage', viewernames: '용도', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_date', viewernames: '건축물일자', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'desc', viewernames: '비고', disabled: false},               
    ];
    let savelist3 = [
        {selltypeCker: [1,2,3], sellstatus: true, key: 'status', viewernames: '상태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'productcode', viewernames: '매물번호', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'create_dt', viewernames: '등록일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'update_dt', viewernames: '확인일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'mediation', viewernames: '공동중개', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'category_2name', viewernames: '매물종류', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'sigungu', viewernames: '시군구', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'dong', viewernames: '법정동', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'jibun', viewernames: '지번', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'title', viewernames: '건물명', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_floor_under_all', viewernames: '지하 총층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_floor_all', viewernames: '지상 총층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_unit_all', viewernames: '총 호수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_unit_empty', viewernames: '공실수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: '?????', viewernames: '공실률', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'area_land', viewernames: '토지면적', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'area_floor', viewernames: '연면적', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'sell_type', viewernames: '거래형태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'price_sell', viewernames: '가격', disabled: true},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_all', viewernames: '현 보증금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_month', viewernames: '현 월세', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'revenue', viewernames: '수익률', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'realinvest', viewernames: '실 투자금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'pypricetype3', viewernames: '평당가(토지)', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'pypricetype4', viewernames: '평당가(건물)', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'price_maintenance', viewernames: '관리비', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car_all', viewernames: '총 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car', viewernames: '세대당 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_direction', viewernames: '방향', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_elevator', viewernames: '승강기', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'client_hp', viewernames: '연락처', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'user', viewernames: '담당자', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'matching', viewernames: '매칭', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_date', viewernames: '건축물일자', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'desc', viewernames: '비고', disabled: false},               
    ];
    //매매
    const [selList1, setselList1] = useState(listset1 ? listset1 : savelist1);   
    const [selList2, setselList2] = useState(listset2 ? listset2 : savelist2);   
    const [selList3, setselList3] = useState(listset3 ? listset3 : savelist3);       

    //전세
    const [selList1_2, setselList1_2] = useState(listset1_2 ? listset1_2 : savelist1);   
    const [selList2_2, setselList2_2] = useState(listset2_2 ? listset2_2 : savelist2);   
    const [selList3_2, setselList3_2] = useState(listset3_2 ? listset3_2 : savelist3);       

    //월세
    const [selList1_3, setselList1_3] = useState(listset1_3 ? listset1_3 : savelist1);   
    const [selList2_3, setselList2_3] = useState(listset2_3 ? listset2_3 : savelist2);   
    const [selList3_3, setselList3_3] = useState(listset3_3 ? listset3_3 : savelist3);       

    
    //매매, 전세, 월세에 따라서 목록이 달라져야 한다.
    
    
    // --- Draggable이 Droppable로 드래그 되었을 때 실행되는 이벤트
    const onDragEnd = ({ source, destination }) => {
        if (!destination) return;
        // 깊은 복사
        // console.log(source);
        // console.log(destination);
        // return;
        let _items = [...selList1];
        if(sell_type_custom === 2){
            _items = [...selList1_2];
        } else if(sell_type_custom === 3){
            _items = [...selList1_3];
        }
        // 기존 아이템 뽑아내기
        let [targetItem] = _items?.splice(source.index, 1);
        // 기존 아이템을 새로운 위치에 삽입하기
        _items?.splice(destination.index, 0, targetItem);
        // 상태 변경

        if(sell_type_custom === 2){
            setselList1_2(_items);
        } else if(sell_type_custom === 3){
            setselList1_3(_items);
        } else {
            setselList1(_items);
        }
    };
  
    const onDragEnd2 = ({ source, destination }) => {
        if (!destination) return;
        // 깊은 복사
        let _items = [...selList2];
        if(sell_type_custom === 2){
            _items = [...selList2_2];
        } else if(sell_type_custom === 3){
            _items = [...selList2_3];
        }
        // 기존 아이템 뽑아내기
        let [targetItem] = _items?.splice(source.index, 1);
        // 기존 아이템을 새로운 위치에 삽입하기
        _items?.splice(destination.index, 0, targetItem);
        // 상태 변경

        if(sell_type_custom === 2){
            setselList2_2(_items);
        } else if(sell_type_custom === 3){
            setselList2_3(_items);
        } else {
            setselList2(_items);
        }
    };
    const onDragEnd3 = ({ source, destination }) => {
        if (!destination) return;
        // 깊은 복사
        let _items = [...selList3];
        if(sell_type_custom === 2){
            _items = [...selList3_2];
        } else if(sell_type_custom === 3){
            _items = [...selList3_3];
        }
        // 기존 아이템 뽑아내기
        let [targetItem] = _items?.splice(source.index, 1);
        // 기존 아이템을 새로운 위치에 삽입하기
        _items?.splice(destination.index, 0, targetItem);
        // 상태 변경

        if(sell_type_custom === 2){
            setselList3_2(_items);
        } else if(sell_type_custom === 3){
            setselList3_3(_items);
        } else {
            setselList3(_items);
        }
    };

    // --- requestAnimationFrame 초기화
    const [enabled, setEnabled] = useState(false);
  
    useEffect(() => {
        const animation = requestAnimationFrame(() => setEnabled(true));

        return () => {
            cancelAnimationFrame(animation);
            setEnabled(false);
        };
    }, []);

    return (
        <div className='listsetpopArea'>
            <div className='popcloseTitle'>
                <span>매물장 설정</span>
                <button
                    onClick={() => {
                        setlistsetpopstatus(false);
                    }}
                >
                    <img src="./images/icons/x.svg" />                                            
                </button>
            </div>

            <div 
                className="searchselect" 
                style={{ 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20, marginTop: 20 
                }}
            >
                <Button buttonTxt={'매매'} styles={{ height: 40, width: 80 }} disabled={sell_type_custom === 1 ? false : true} onPress={() => setsell_type_custom(1) } />
                <Button buttonTxt={'전세'} styles={{ height: 40, width: 80 }} disabled={sell_type_custom === 2 ? false : true} onPress={() => setsell_type_custom(2) } />
                <Button buttonTxt={'월세'} styles={{ height: 40, width: 80 }} disabled={sell_type_custom === 3 ? false : true} onPress={() => setsell_type_custom(3) } />
            </div>
                       
            {sell_type_custom === 1 &&
            <div className='listsetarea2 margint20' style={{ alignItems: 'flex-start'}}>
                <div>
                    <div>주거용</div>
                    <div className='margint12'>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {selList1?.length > 0 && selList1?.map((x, i) => {
                                        if(!x?.selltypeCker?.find((x) => x*1 === sell_type_custom*1)){
                                            return;
                                        }                                           
                                        return (
                                            <Draggable key={"thkey1"+i} draggableId={"dthkey1"+i} index={i}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}    
                                                    onClick={() => {
                                                        if(x?.disabled === false){
                                                            setselList1(selList1?.map((item, index) => index === i ? {...item, sellstatus: !x?.sellstatus} : item));
                                                        }                                        
                                                    }}
                                                    className={`${x?.disabled === true ? 'disabled' : x?.sellstatus === true ? 'active' : ''}`}
                                                >
                                                    {x?.viewernames}                                       
                                                </div>  
                                            )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
                <div>
                    <div>상업용</div>
                    <div className='margint12'>
                        <DragDropContext onDragEnd={onDragEnd2}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {selList2?.length > 0 && selList2?.map((x, i) => {
                                        if(!x?.selltypeCker?.find((x) => x*1 === sell_type_custom*1)){
                                            return;
                                        }                                           
                                        return (
                                            <Draggable key={"thkey1"+i} draggableId={"dthkey1"+i} index={i}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}    
                                                    onClick={() => {
                                                        if(x?.disabled === false){
                                                            setselList2(selList2?.map((item, index) => index === i ? {...item, sellstatus: !x?.sellstatus} : item));
                                                        }                                        
                                                    }}
                                                    className={`${x?.disabled === true ? 'disabled' : x?.sellstatus === true ? 'active' : ''}`}
                                                >
                                                    {x?.viewernames}                                       
                                                </div>  
                                            )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
                <div>
                    <div>건물</div>
                    <div className='margint12'>
                        <DragDropContext onDragEnd={onDragEnd3}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {selList3?.length > 0 && selList3?.map((x, i) => {
                                        if(!x?.selltypeCker?.find((x) => x*1 === sell_type_custom*1)){
                                            return;
                                        }                                           
                                        return (
                                            <Draggable key={"thkey1"+i} draggableId={"dthkey1"+i} index={i}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}    
                                                    onClick={() => {
                                                        if(x?.disabled === false){
                                                            setselList3(selList3?.map((item, index) => index === i ? {...item, sellstatus: !x?.sellstatus} : item));
                                                        }                                        
                                                    }}
                                                    className={`${x?.disabled === true ? 'disabled' : x?.sellstatus === true ? 'active' : ''}`}
                                                >
                                                    {x?.viewernames}                                       
                                                </div>  
                                            )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                                )}
                            </Droppable>
                        </DragDropContext>

                    </div>
                </div>                
            </div>
            }
            {sell_type_custom === 2 &&
            <div className='listsetarea2 margint20' style={{ alignItems: 'flex-start'}}>
                <div>
                    <div>주거용</div>
                    <div className='margint12'>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {selList1_2?.length > 0 && selList1_2?.map((x, i) => {
                                        if(!x?.selltypeCker?.find((x) => x*1 === sell_type_custom*1)){
                                            return;
                                        }                                           
                                        return (
                                            <Draggable key={"thkey1"+i} draggableId={"dthkey1"+i} index={i}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}    
                                                    onClick={() => {
                                                        if(x?.disabled === false){
                                                            setselList1_2(selList1_2?.map((item, index) => index === i ? {...item, sellstatus: !x?.sellstatus} : item));
                                                        }                                        
                                                    }}
                                                    className={`${x?.disabled === true ? 'disabled' : x?.sellstatus === true ? 'active' : ''}`}
                                                >
                                                    {x?.viewernames}                                       
                                                </div>  
                                            )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
                <div>
                    <div>상업용</div>
                    <div className='margint12'>
                        <DragDropContext onDragEnd={onDragEnd2}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {selList2_2?.length > 0 && selList2_2?.map((x, i) => {
                                        if(!x?.selltypeCker?.find((x) => x*1 === sell_type_custom*1)){
                                            return;
                                        }                                           
                                        return (
                                            <Draggable key={"thkey1"+i} draggableId={"dthkey1"+i} index={i}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}    
                                                    onClick={() => {
                                                        if(x?.disabled === false){
                                                            setselList2_2(selList2_2?.map((item, index) => index === i ? {...item, sellstatus: !x?.sellstatus} : item));
                                                        }                                        
                                                    }}
                                                    className={`${x?.disabled === true ? 'disabled' : x?.sellstatus === true ? 'active' : ''}`}
                                                >
                                                    {x?.viewernames}                                       
                                                </div>  
                                            )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
                <div>
                    <div>건물</div>
                    <div className='margint12'>
                        <DragDropContext onDragEnd={onDragEnd3}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {selList3_2?.length > 0 && selList3_2?.map((x, i) => {
                                        if(!x?.selltypeCker?.find((x) => x*1 === sell_type_custom*1)){
                                            return;
                                        }                                           
                                        return (
                                            <Draggable key={"thkey1"+i} draggableId={"dthkey1"+i} index={i}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}    
                                                    onClick={() => {
                                                        if(x?.disabled === false){
                                                            setselList3_2(selList3_2?.map((item, index) => index === i ? {...item, sellstatus: !x?.sellstatus} : item));
                                                        }                                        
                                                    }}
                                                    className={`${x?.disabled === true ? 'disabled' : x?.sellstatus === true ? 'active' : ''}`}
                                                >
                                                    {x?.viewernames}                                       
                                                </div>  
                                            )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                                )}
                            </Droppable>
                        </DragDropContext>

                    </div>
                </div>                
            </div>
            }
            {sell_type_custom === 3 &&
                <div className='listsetarea2 margint20' style={{ alignItems: 'flex-start'}}>
                <div>
                    <div>주거용</div>
                    <div className='margint12'>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {selList1_3?.length > 0 && selList1_3?.map((x, i) => {
                                        if(!x?.selltypeCker?.find((x) => x*1 === sell_type_custom*1)){
                                            return;
                                        }                                           
                                        return (
                                            <Draggable key={"thkey1"+i} draggableId={"dthkey1"+i} index={i}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}    
                                                    onClick={() => {
                                                        if(x?.disabled === false){
                                                            setselList1_3(selList1_3?.map((item, index) => index === i ? {...item, sellstatus: !x?.sellstatus} : item));
                                                        }                                        
                                                    }}
                                                    className={`${x?.disabled === true ? 'disabled' : x?.sellstatus === true ? 'active' : ''}`}
                                                >
                                                    {x?.viewernames}                                       
                                                </div>  
                                            )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
                <div>
                    <div>상업용</div>
                    <div className='margint12'>
                        <DragDropContext onDragEnd={onDragEnd2}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {selList2_3?.length > 0 && selList2_3?.map((x, i) => {
                                        if(!x?.selltypeCker?.find((x) => x*1 === sell_type_custom*1)){
                                            return;
                                        }                                           
                                        return (
                                            <Draggable key={"thkey1"+i} draggableId={"dthkey1"+i} index={i}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}    
                                                    onClick={() => {
                                                        if(x?.disabled === false){
                                                            setselList2_3(selList2_3?.map((item, index) => index === i ? {...item, sellstatus: !x?.sellstatus} : item));
                                                        }                                        
                                                    }}
                                                    className={`${x?.disabled === true ? 'disabled' : x?.sellstatus === true ? 'active' : ''}`}
                                                >
                                                    {x?.viewernames}                                       
                                                </div>  
                                            )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
                <div>
                    <div>건물</div>
                    <div className='margint12'>
                        <DragDropContext onDragEnd={onDragEnd3}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {selList3_3?.length > 0 && selList3_3?.map((x, i) => {
                                        if(!x?.selltypeCker?.find((x) => x*1 === sell_type_custom*1)){
                                            return;
                                        }                                           
                                        return (
                                            <Draggable key={"thkey1"+i} draggableId={"dthkey1"+i} index={i}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}    
                                                    onClick={() => {
                                                        if(x?.disabled === false){
                                                            setselList3_3(selList3_3?.map((item, index) => index === i ? {...item, sellstatus: !x?.sellstatus} : item));
                                                        }                                        
                                                    }}
                                                    className={`${x?.disabled === true ? 'disabled' : x?.sellstatus === true ? 'active' : ''}`}
                                                >
                                                    {x?.viewernames}                                       
                                                </div>  
                                            )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                                )}
                            </Droppable>
                        </DragDropContext>

                    </div>
                </div>                
            </div>
            }

            <div className='listsetarea3 margint13' style={{ alignItems: 'flex-start' }}>
                <div>매물목록 첫화면 설정</div>
                <div
                    style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', gap: 10}}
                >
                    <Radios
                        linetype={'radioimg'}
                        values={sell_type}
                        setvalues={setsell_type}
                        namevalue={[
                            {names: '매매', values: 1},
                            {names: '전세', values: 2},
                            {names: '월세', values: 3},
                        ]}
                        fontweights={400}
                        fontSizes={14}
                        sizes={20}
                    />  
                                        
                    <Radios
                        linetype={'radioimg'}
                        values={category_1}
                        setvalues={setcategory_1}
                        namevalue={[
                            {names: '주거', values: 1},
                            {names: '상업', values: 2},
                            {names: '건물', values: 3},
                        ]}
                        fontweights={400}
                        fontSizes={14}
                        sizes={20}
                    />     
                </div>           
            </div>
            <div className='listsetarea3 margint20'>회색 항목은 선택 불가능한 필수 매물장표기사항 입니다.</div>
            <div className='listsetarea4 margint4'>
                거래 형태/매물 종류 별로 자유롭게 선택하셔서 본인에게 맞는 매물장을 구성할 수 있습니다.<br />
                목록을 위 아래로 드래그하여 순서를 변경할 수 있습니다.
            </div>
            <div className="filterbuttonsarea margint20">
                <div>
                    <Button
                        onPress={() => {
                            //navigate('/Main');
                            dispatch(listsetting1({listset1: selList1}));     
                            dispatch(listsetting2({listset2: selList2}));     
                            dispatch(listsetting3({listset3: selList3}));     
                            dispatch(listsetting1_2({listset1_2: selList1_2}));     
                            dispatch(listsetting2_2({listset2_2: selList2_2}));     
                            dispatch(listsetting3_2({listset3_2: selList3_2}));     
                            dispatch(listsetting1_3({listset1_3: selList1_3}));     
                            dispatch(listsetting2_3({listset2_3: selList2_3}));     
                            dispatch(listsetting3_3({listset3_3: selList3_3}));     

                            dispatch(
                                seltypeorcategory({
                                    seltypes: sell_type,
                                    category_1s: category_1
                                })
                            );

                            setselList1(selList1);//매매->주거
                            setselList2(selList2);//매매->상업
                            setselList3(selList3);//매매->건물
                            setselList1_2(selList1_2);//전세->주거
                            setselList2_2(selList2_2);//전세->상업
                            setselList3_2(selList3_2);//전세->건물
                            setselList1_3(selList1_3);//월세->주거
                            setselList2_3(selList2_3);//월세->상업
                            setselList3_3(selList3_3);//월세->건물
                            
                            let sender = {
                                type:sell_type,
                                category:category_1,
                                sel_list1:JSON.stringify(selList1),
                                sel_list2:JSON.stringify(selList2),
                                sel_list3:JSON.stringify(selList3),
                                sel_list1_2:JSON.stringify(selList1_2),
                                sel_list2_2:JSON.stringify(selList2_2),
                                sel_list3_2:JSON.stringify(selList3_2),
                                sel_list1_3:JSON.stringify(selList1_3),
                                sel_list2_3:JSON.stringify(selList2_3),
                                sel_list3_3:JSON.stringify(selList3_3),
                            }
                            APIS.postData('/v1/item/selsetUpdate', sender).then(({ data }) => {
                                console.log("성공")
                            }).catch((e) => {
                                console.log(e);
                            })

                            setlistsetpopstatus(false);
                        }}                    
                        buttonTxt={'설정완료'}
                    />
                </div>
                <div>
                    <Button
                        titleimgs={`./images/icons/loop-left-line-purple.svg`}
                        buttonTxt={'초기화'}
                        className={'linenormalbutton'}
                        onPress={() => {
                            //navigate('/Main');

                            dispatch(listsetting1({listset1: savelist1}));     
                            dispatch(listsetting2({listset2: savelist2}));     
                            dispatch(listsetting3({listset3: savelist3}));     
                            dispatch(listsetting1_2({listset1_2: savelist1}));     
                            dispatch(listsetting2_2({listset2_2: savelist2}));     
                            dispatch(listsetting3_2({listset3_2: savelist3}));     
                            dispatch(listsetting1_3({listset1_3: savelist1}));     
                            dispatch(listsetting2_3({listset2_3: savelist2}));     
                            dispatch(listsetting3_3({listset3_3: savelist3}));     

                            dispatch(
                                seltypeorcategory({
                                    seltypes: 1,
                                    category_1s: 1
                                })
                            );            
                            setsell_type(1);
                            setcategory_1(1);
                            setselList1(savelist1);
                            setselList2(savelist2);
                            setselList3(savelist3);                   
                            setselList1_2(savelist1);
                            setselList2_2(savelist2);
                            setselList3_2(savelist3);                   
                            setselList1_3(savelist1);
                            setselList2_3(savelist2);
                            setselList3_3(savelist3);                   
                            //navigate('/Register');

                            let sender = {
                                type:1,
                                category:2,
                                sel_list1:JSON.stringify(savelist1),
                                sel_list2:JSON.stringify(savelist2),
                                sel_list3:JSON.stringify(savelist3),
                                sel_list1_2:JSON.stringify(savelist1),
                                sel_list2_2:JSON.stringify(savelist2),
                                sel_list3_2:JSON.stringify(savelist3),
                                sel_list1_3:JSON.stringify(savelist1),
                                sel_list2_3:JSON.stringify(savelist2),
                                sel_list3_3:JSON.stringify(savelist3),
                            }
                            APIS.postData('/v1/item/selsetUpdate', sender).then(({ data }) => {
                                console.log("성공")
                            }).catch((e) => {
                                console.log(e);
                            })
                        }}                             
                    />
                </div>
            </div>  
        </div>
    )    
}